module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    php版本设置\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('p', {
    staticClass: "left-desc"
  }, [_vm._v("切换版本类型")]), _vm._v(" "), _c('div', {
    staticClass: "right-select-box flex1 flex",
    attrs: {
      "id": "upgradeSpace"
    }
  }, _vm._l((_vm.choose), function(item, index) {
    return _c('span', {
      staticClass: "another-option flex1per2",
      class: {
        'selected': _vm.phpselect == item.value
      },
      on: {
        "click": function($event) {
          _vm.Choose(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))])])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".5rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("如果您的网站基于PHP，请选择适用您程序的PHP版本")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3944d536","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/phpselect.vue
// module id = ew9Y
// module chunks = 1